function lineToneClass(tone) {
  if (tone === 'primary') return 'border-primary'
  if (tone === 'secondary') return 'border-secondary'
  return 'border-surface-variant'
}

function timeToneClass(tone) {
  if (tone === 'primary') return 'text-primary-container'
  if (tone === 'secondary') return 'text-secondary'
  return 'text-on-surface-variant'
}

export default function ScheduleCard({ items, onOpenActionCenter }) {
  const rows = Array.isArray(items) ? items : []
  return (
    <article className="rounded-lg bg-surface-container-lowest p-6 shadow-sm">
      <div className="mb-6 flex items-center justify-between">
        <h3 className="text-[11px] font-semibold uppercase tracking-wider text-on-surface-variant">
          Today's Schedule
        </h3>
        <button
          type="button"
          onClick={onOpenActionCenter}
          className="rounded-full p-1 text-on-surface-variant transition-colors hover:bg-surface-container-low"
        >
          <span className="material-symbols-outlined text-lg">add_circle</span>
        </button>
      </div>

      <div className="space-y-5">
        {rows.map((item) => (
          <div key={`${item.time}-${item.title}`} className={`relative border-l-2 pl-4 ${lineToneClass(item.tone)}`}>
            <p className={`text-[10px] font-bold ${timeToneClass(item.tone)}`}>{item.time}</p>
            <p className="text-sm font-bold text-on-surface">{item.title}</p>
            <p className="text-[10px] uppercase text-on-surface-variant">{item.note}</p>
          </div>
        ))}
      </div>
    </article>
  )
}
